// extracted by mini-css-extract-plugin
export default {"root":"BrandArchivedContainer_root__GMKRn"};